module.exports = __webpack_public_path__ + "images/start.a8b144532faf8eb9c6d9c251c0ff8e86.png";